export default {
  downloads: {
    description:
      "Software útil para el diagnóstico y programación de máquinas Brokk.",
    itemName: "Software",
    size: "Tamaño",
    subtitle: "Descargar software para máquinas Brokk."
  }
}
